import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getImageVisual } from "../../data/visuals";

import styles from "./viz-image.css";

import type { ImageVisualData } from "../../types.d";
import type { PropertyValues } from "lit";

@customElement("bp-viz-image")
export class VizImage extends LitElement {
  static styles = styles;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: ImageVisualData;

  render() {
    if (!this.data) return;

    const { src, alt, caption } = this.data;

    return html`
      <figure>
        <img src=${src} alt=${alt} title=${alt} />

        ${caption && html`<bp-caption>${unsafeHTML(caption)}</bp-caption>`}
      </figure>
    `;
  }

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getImageVisual(this.arcId)
      .then(({ data }) => {
        this.data = data;
      })
      .catch(() => undefined);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-viz-image": VizImage;
  }
}
